import OptionsStatus from './OptionsStatus';
import {
  AI_AGENT_LABELS,
  formatLabel,
  formatModelLabel,
  getAiModelKey,
  type AgentModelsByAgent,
  type LoadState
} from './workflowShared';

interface AgentsStepProps {
  loadState: LoadState;
  loadError: string;
  availableAiAgents: string[];
  agentModelsByAgent: AgentModelsByAgent;
  selectedAiModels: Set<string>;
  onRetryLoadOptions: () => void;
  onToggleModel: (agent: string, model: string) => void;
}

function AgentsStep({
  loadState,
  loadError,
  availableAiAgents,
  agentModelsByAgent,
  selectedAiModels,
  onRetryLoadOptions,
  onToggleModel
}: AgentsStepProps) {
  return (
    <>
      <div className="step-heading">
        <h1>Choose AI models</h1>
        <p>Select one or more AI models to run against the repository.</p>
      </div>

      <OptionsStatus loadState={loadState} loadError={loadError} onRetry={onRetryLoadOptions} />

      {loadState === 'ready' && (
        <div className="agents-step-list">
          {availableAiAgents.map((agent) => {
            const models = agentModelsByAgent[agent] || [];

            if (models.length === 0) {
              return null;
            }

            return (
              <div className="agents-step-group" key={agent}>
                <h3 className="agents-step-title">{formatLabel(agent, AI_AGENT_LABELS)}</h3>

                <div className="agents-step-model-list">
                  {models.map((model) => {
                    const isModelSelected = selectedAiModels.has(getAiModelKey(agent, model));

                    return (
                      <button
                        key={model}
                        className={`skill-chip ${isModelSelected ? 'selected' : ''}`}
                        type="button"
                        onClick={() => onToggleModel(agent, model)}
                      >
                        <span className="checkbox-mark" aria-hidden="true" />
                        <span>{formatModelLabel(model)}</span>
                      </button>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </>
  );
}

export default AgentsStep;
